<app-application-template-form-dialog
    [form]="form"
    (submission)="createTemplate()"
    (closeDialog)="closeDialog()"
    (checkTemplateNameExistence)="checkTemplateNameExistence()"
    class="h-full"
>
    ></app-application-template-form-dialog
>
